import {
  Box,
  Card,
  CardContent,
  createStyles,
  Grid,
  LinearProgress,
  makeStyles,
  Paper,
  Typography,
} from '@material-ui/core';
import * as React from 'react';
import scan from '../../assets/icons/scan.svg';
import type { IRepairsScannedProps } from './MassReceiveInterfaces';

const useStyles = makeStyles(() => createStyles({
  title: {
    fontWeight: 700,
    fontSize: 18,
  },
  repairsScannedSvg: {
    height: 24,
    width: 24,
    marginBottom: 7,
  },
  barcodeCards: {
    height: 70,
    width: 210,
  },
  unscannedRepairCount: {
    border: '2px dashed #8D8D8D',
    borderWidth: 2,
    padding: '13px 16px',
    width: 176,
    height: 40,
  },
  scannedRepairBarcode: {
    color: '#6CAE75',
  },
}));

const RepairsScanned: React.FC<IRepairsScannedProps> = (
  {
    unscannedRepairs,
    scannedRepairs,
    scanRepair,
    unscannedColumnText = 'Repairs not in system',
  },
) => {
  const classes = useStyles();

  const progress = React.useMemo(() => (scannedRepairs.length / (scannedRepairs.length + unscannedRepairs.length)) * 100, [scannedRepairs.length, unscannedRepairs.length]);

  return (
    <>
      <Grid item xs={12}>
        <Paper>
          <Box p={2}>
            <Grid container spacing={2}>
              <img src={scan} alt="scan.svg" className={classes.repairsScannedSvg} />
              <Grid item xs={12}>
                <Typography className={classes.title}>{'Progress of repairs scanned in'}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Box display="flex" alignItems="center">
                  <Box width="100%" mr={1}>
                    <LinearProgress variant="determinate" value={progress} />
                  </Box>
                  <Box minWidth={35}>
                    <Typography variant="body2" color="textSecondary">{`${Math.round(progress)}%`}</Typography>
                  </Box>
                </Box>
              </Grid>

              <Grid container direction="column" alignItems="flex-start" item xs={6} spacing={1}>
                <Box style={{ height: (unscannedRepairs.length + scannedRepairs.length + 1) * 84 }}>
                  <Typography variant="caption" color="textSecondary">{unscannedColumnText}</Typography>
                  {unscannedRepairs.map((ur) => (
                    <Box my={1}>
                      <Card className={classes.barcodeCards} onClick={() => scanRepair(ur.barcode)}>
                        <CardContent>
                          <Typography color="primary">{`${ur.barcode}`}</Typography>
                          <Typography variant="caption">{ur?.groupNumber ? `Grouping ${ur.groupNumber}` : 'Repair'}</Typography>
                        </CardContent>
                      </Card>
                    </Box>
                  ))}
                </Box>
              </Grid>
              <Grid container direction="column" alignItems="flex-end" item xs={6} spacing={1}>
                <Typography variant="caption" align="right" color="textSecondary">{'Repairs scanned in'}</Typography>
                <Box my={1}>
                  <Paper className={classes.unscannedRepairCount} elevation={0}>
                    <Typography color="textSecondary">{`${unscannedRepairs.length} repairs`}</Typography>
                    <Typography variant="caption" color="textSecondary">{'Remaining to be scanned'}</Typography>
                  </Paper>
                </Box>
                {scannedRepairs.map((sr) => (
                  <Box my={1}>
                    <Card className={classes.barcodeCards}>
                      <CardContent>
                        <Typography className={classes.scannedRepairBarcode}>{`${sr.barcode}`}</Typography>
                        <Typography variant="caption">{sr?.groupNumber ? `Grouping ${sr.groupNumber}` : 'Repair'}</Typography>
                      </CardContent>
                    </Card>
                  </Box>
                ))}
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Grid>

    </>
  );
};

export default RepairsScanned;
